<template lang="pug">

.page.page_offset_top.page_offset_bottom
  .page-meta
    .container
      .page-meta__inner
        breadcrumbs

  .login
    .container
      .login__inner
        .login__caption
          h1.login__title.title.title_size_l Вход в BelkaCar
          p.login__desc {{ desc }}

        //- Без отправки смс частного лица
        template(v-if="!msgSended")
          form.login-form(@submit.prevent="validateBeforeSubmit")
            .login-form__inner
              label.login-form__field(:class="[{'login-form__field_notempty' : login !== ''}, {'login-form__field_has_error' : errors.has('login')}]"
               @focus="checkValue" @keyup="checkValue" @change="checkValue")
                input.login-form__input.input(v-validate="'required|alpha'" name="login" v-model="login"  :type='corporate ? "text" : "tel"')
                span.login-form__label {{ loginLabel }}
              //- Корпорация
              template(v-if="corporate")
                label.login-form__field(:class="{'login-form__field_notempty' : password !== ''}")
                  input.login-form__input.input(type="password" v-model="password")
                  span.login-form__label пароль
                button(type="submit" v-if="password.length >= 1").btn.btn_theme_dark-blue.btn_size_m.btn_center.login-form__btn войти
              //- Частное лицо
              template(v-if="person")
                button(type="submit" v-if="login.length >= 5").btn.btn_theme_dark-blue.btn_size_m.btn_center.login-form__btn Выслать sms
        //- После отправки смс частного лица
        template(v-else)
          form.login-form(@submit.prevent="validateBeforeSubmit")
            .login-form__inner
              label.login-form__field(:class="{'login-form__field_notempty' : code !== ''}" @focus="checkValue" @keyup="checkValue" @change="checkValue")
                the-mask.login-form__input.input.input_center(mask="####" v-validate="'required|numeric|min:4'" type="numbers" placeholder="XXXX" v-model="code")
              .login-form__info
                a(href="#").login-form__time(@click.prevent="sendMsgAgain" v-if="!msgSendedAgain") Отправить еще раз
                .login-form__time(v-else) Отправить СМС повторно через: #[span {{ time }}]
                a(href="#" @click.prevent="resetLogin").login-form__back Вернуться

</template>

<script>
export default {
  props: [],
  components: {},
  data () {
    return {
      sec: 120,
      time: 0,
      login: '',
      password: '',
      code: '',
      desc: 'Если вы частное лицо, введите телефон, который был указан при регистрации. Если корпоративный клиент — логин.',
      person: false,
      corporate: false,
      loginLabel: 'введите телефон или логин',
      msgSended: false,
      msgSendedAgain: false
    }
  },
  methods: {
    checkValue () {
      if (isNaN(this.login)) {
        this.corporate = true
        this.person = false
        this.loginLabel = 'Логин'
      } else if (this.login === '') {
        this.corporate = false
        this.person = false
        this.password = ''
        this.loginLabel = 'введите телефон или логин'
      } else {
        this.loginLabel = 'Номер телефона'
        this.person = true
        this.corporate = false
      }
    },
    validateBeforeSubmit (e) {
      if (this.person) {
        this.desc = `Введите 4-х значный пароль из SMS, отправленный на номер: ${this.login}`
        this.msgSended = !this.msgSended
        this.sendMsgAgain()
        this.login = ''
      }
      if (this.corporate) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.login = null
            this.password = null
            this.$validator.reset()
          }
        })
      }
    },
    sendMsgAgain () {
      this.sec = 120
      this.timer()
    },
    timer () {
      this.msgSendedAgain = true
      this.sec--
      const concatSecond = this.sec % 60 <= 10 ? '0' + this.sec % 60 : this.sec % 60
      this.time = Math.floor(this.sec / 60) + ':' + concatSecond
      if (this.sec < 0) {
        this.msgSendedAgain = false
      } else {
        setTimeout(this.timer, 1000)
      }
    },
    resetLogin () {
      this.msgSended = false
      this.desc = 'Если вы частное лицо, введите телефон, который был указан при регистрации. Если корпоративный клиент — логин.'
    },
    clear () {
      this.login = null
      this.password = null
    }
  },
  computed: {
  },
  mounted () {
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/views/Login.vue